import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'filter',
 standalone: true,
})
export class FilterPipe implements PipeTransform {
 transform(data: any[], filterProperty: string, filter: string): any[] {

  if (data && filterProperty && filter) {
   return data.filter((item) => {
    const propertyValue = this.getNestedProperty(item, filterProperty);
    return propertyValue?.includes(filter);
   });
  } else {
   return data;
  }
 }

 private getNestedProperty(obj: any, path: string): any {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
 }
}
